import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import {
  FaArrowLeft, FaPhone, FaEnvelope, FaCommentDots,
  FaMapMarkerAlt, FaStar, FaCheckCircle, FaRegStar
} from "react-icons/fa";
import { AUTH_STORAGE_KEY } from "../socket";
import MobileBottomNav from '../components/layout/MobileBottomNav';
import "./LandingPage.css";
import "./BusinessProfile.css";
import CommonNavbar from "../components/CommonNavbar";
 
function getToken() {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    return raw ? JSON.parse(raw)?.token : null;
  } catch { return null; }
}

function authHeader() {
  const token = getToken();
  return token
    ? { Authorization: "Bearer " + token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

async function createLead(serviceId) {
  if (!serviceId) return;
  try {
    const now = new Date();
    await fetch("/api/bookings", {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify({
        serviceId,
        scheduledDate: now.toISOString().slice(0, 10),
        scheduledTime: now.toTimeString().slice(0, 8),
        notes: "Lead created from profile action",
      }),
    });
  } catch (err) { console.warn("Failed to create lead", err); }
}

async function savePredefinedChatMessage(toEmail, serviceName) {
  if (!toEmail) return;
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    const currentUser = parsed?.user?.email || parsed?.user?.username || "";
    await fetch("/api/chats/save-message", {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify({
        from: currentUser,
        to: toEmail,
        text: `Hi! I'm interested in your ${serviceName} service. Can we discuss details?`,
        timestamp: new Date().toISOString(),
      }),
    }).catch(() => {});
  } catch (err) { console.warn("Failed to save predefined message", err); }
}

const OFFER_COLORS = ["#1D9E75", "#378ADD", "#f7971e", "#7F77DD", "#D85A30", "#0F6E56"];
const TABS = [ "Services", "Catalog", "Business Details", "Reviews"];

const S = {
  shell: {
    fontFamily: "'DM Sans', sans-serif",
    padding: "76px 16px 80px",
    color: "#1a1a2e",
    background: "#fff",
    margin: "0 auto",
  },
  backBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 20,
    background: "black",
    border: "none",
    color: "#fcfbfb",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
    padding: 10,
    borderRadius: 6,
  },
  navBar: {
    display: "flex",
    borderBottom: "1.5px solid #e8eaf0",
    marginBottom: 18,
    overflowX: "auto",
    position: "sticky",
    top: 60,
    gap: 20,
    background: "#fff",
    zIndex: 10,
    padding: "10px 15px",
  },
  sectionLabel: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1,
    textTransform: "uppercase",
    color: "#000",
    marginBottom: 12,
  },
  sectionWrap: {
    marginBottom: 40,
    scrollMarginTop: 120,
  },
  offerList: {
    background: "#fff",
    borderRadius: 16,
    border: "1px solid #eef0f5",
    overflow: "hidden",
    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
    marginBottom: 28,
  },
  offerItem: {
    display: "flex",
    alignItems: "center",
    gap: 13,
    padding: "14px 18px",
    fontSize: 14,
    color: "#1a1a2e",
    fontWeight: 500,
  },
  offerIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontSize: 15,
  },
  catalogGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: 14,
  },
  catalogCard: {
    background: "#fff",
    borderRadius: 16,
    border: "1px solid #eef0f5",
    overflow: "hidden",
    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
    transition: "transform 0.15s, box-shadow 0.15s",
  },
  catalogImg: { width: "100%", height: 180, objectFit: "cover", display: "block" },
  catalogBody: { padding: "12px 14px" },
  catalogTitle: { fontWeight: 700, fontSize: 14, marginBottom: 4, color: "#1a1a2e" },
  catalogDesc: {
    fontSize: 12, color: "#444", marginBottom: 8, lineHeight: 1.5,
    display: "-webkit-box", WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical", overflow: "hidden",
  },
  catalogPrice: { fontSize: 15, fontWeight: 700, color: "#1D9E75" },
  detailsCard: {
    background: "#f9fafb", borderRadius: 16,
    border: "1px solid #eef0f5", padding: "20px 24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
  },
  detailRow: {
    display: "flex", gap: 12, padding: "12px 0",
    borderBottom: "1px solid #f0f2f6", alignItems: "flex-start",
  },
  detailIcon: {
    width: 36, height: 36, borderRadius: 10, background: "#e8f0fe",
    display: "flex", alignItems: "center", justifyContent: "center",
    color: "#378ADD", flexShrink: 0, fontSize: 15,
  },
  detailLabel: {
    fontSize: 11, fontWeight: 700, color: "#888",
    textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 3,
  },
  detailValue: { fontSize: 14, color: "#1a1a2e", fontWeight: 500, lineHeight: 1.5 },
  reviewCard: {
    background: "#fff", borderRadius: 14, border: "1px solid #eef0f5",
    padding: "16px 18px", marginBottom: 14,
    boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
  },
  reviewHeader: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between", marginBottom: 8,
  },
  reviewAvatar: {
    width: 36, height: 36, borderRadius: "50%",
    background: "linear-gradient(135deg,#378ADD,#1D9E75)",
    display: "flex", alignItems: "center", justifyContent: "center",
    color: "#fff", fontWeight: 700, fontSize: 14, flexShrink: 0,
  },
  reviewAuthor: { fontWeight: 700, fontSize: 14, color: "#1a1a2e" },
  reviewDate: { fontSize: 11, color: "#aaa", marginTop: 2 },
  reviewText: { fontSize: 14, color: "#444", lineHeight: 1.6, marginTop: 6 },
  addReviewBox: {
    background: "#f9fafb", borderRadius: 16,
    border: "1px solid #eef0f5", padding: "20px 24px", marginTop: 20,
  },
  textarea: {
    width: "100%", minHeight: 90, borderRadius: 10,
    border: "1.5px solid #e0e4ed", padding: "12px 14px",
    fontSize: 14, fontFamily: "'DM Sans', sans-serif",
    color: "#1a1a2e", resize: "vertical", outline: "none",
    boxSizing: "border-box", marginTop: 10, marginBottom: 14, background: "#fff",
  },
  submitBtn: {
    background: "#1D9E75", color: "#fff", border: "none",
    borderRadius: 10, padding: "12px 28px", fontSize: 14,
    fontWeight: 700, cursor: "pointer", transition: "opacity 0.2s",
  },
};

function NavItem({ label, active, onClick }) {
  return (
    <button onClick={onClick} style={{
      background: "none", border: "none",
      borderBottom: active ? "2.5px solid #f7971e" : "2.5px solid transparent",
      color: active ? "#f7971e" : "#666",
      fontFamily: "inherit", fontWeight: 600, fontSize: 13,
      padding: "10px 18px", cursor: "pointer",
      whiteSpace: "nowrap", transition: "color 0.15s",
    }}>
      {label}
    </button>
  );
}

function StarRating({ value, onChange, size = 24 }) {
  const [hovered, setHovered] = useState(0);
  return (
    <div style={{ display: "flex", gap: 4 }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          style={{ cursor: "pointer", fontSize: size, color: (hovered || value) >= star ? "#f7971e" : "#ddd" }}
          onMouseEnter={() => setHovered(star)}
          onMouseLeave={() => setHovered(0)}
          onClick={() => onChange(star)}
        >
          {(hovered || value) >= star ? <FaStar /> : <FaRegStar />}
        </span>
      ))}
    </div>
  );
}
const getDisplayName = (value) => {
  if (!value) return "U";

  const [name, domain] = value.split("@");

  if (!domain) {
    // if no email, fallback to initials
    return value.slice(0, 2).toUpperCase();
  }

  const shortName = name.slice(0, 3); // Tej
  return `${shortName}...@${domain}`;
};

function ReviewStars({ rating }) {
  return (
    <span style={{ display: "inline-flex", gap: 2 }}>
      {[1, 2, 3, 4, 5].map((s) => (
        <FaStar key={s} size={12} color={rating >= s ? "#f7971e" : "#ddd"} />
      ))}
    </span>
  );
}

function extractBusinessId(routeParam) {
  const candidate = String(routeParam || "").trim();
  if (!candidate) return "";
  const uuidMatch = candidate.match(/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})$/i);
  return uuidMatch ? uuidMatch[1] : candidate;
}

export default function BusinessProfile() {
  const { slugOrId } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("Services");
  const [searchQuery, setSearchQuery] = useState("");
  const [reviews, setReviews] = useState([]);
  const [reviewText, setReviewText] = useState("");
  const [reviewRating, setReviewRating] = useState(0);
  const [reviewSubmitting, setReviewSubmitting] = useState(false);
  const [reviewMsg, setReviewMsg] = useState("");
  const [replyDrafts, setReplyDrafts] = useState({});
  const [replyOpen, setReplyOpen] = useState({});
  const [replySubmitting, setReplySubmitting] = useState({});
  const [previewImage, setPreviewImage] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const getCurrentUserId = () => {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : {};
      return parsed?.user?.userId || parsed?.user?.email || parsed?.user?.username || "";
    } catch {
      return "";
    }
  };
  const currentUserId = getCurrentUserId();
  const isOwner = service?.ownerId && currentUserId && service.ownerId === currentUserId;

  const isLoggedIn = () => !!localStorage.getItem(AUTH_STORAGE_KEY);

  const businessId = extractBusinessId(slugOrId);

  const sectionRefs = {
    Services: useRef(null),
    Catalog: useRef(null),
    "Business Details": useRef(null),
    Reviews: useRef(null),
  };
   useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 640);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  useEffect(() => {
    (async () => {
      setLoading(true); setError(null);
      try {
        const res = await fetch(`/api/allservices/${businessId}`);
        if (!res.ok) throw new Error(`Unable to load business profile (${res.status})`);
        const data = await res.json();
        setService(data.service);
      } catch (err) {
        setError(err.message || "Failed to load business profile.");
      } finally { setLoading(false); }
    })();
  }, [businessId]);

  useEffect(() => {
    if (!businessId) return;
    fetch(`/api/reviews/${businessId}`)
      .then((r) => r.json())
      .then((data) => setReviews(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, [businessId]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY + 140;
      let current = "Services";
      TABS.forEach((tab) => {
        const el = sectionRefs[tab]?.current;
        if (el && el.offsetTop <= scrollY) current = tab;
      });
      setActiveTab(current);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (tab) => {
    const el = sectionRefs[tab]?.current;
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: "smooth" });
    }
    setActiveTab(tab);
  };

  const handleMail = () => {
    if (!isLoggedIn()) { navigate("/login"); return; }
    navigate("/kmail", { state: { composeTo: service.ownerId } });
  };

  const handleReplyChange = (reviewId, value) => {
    setReplyDrafts((prev) => ({ ...prev, [reviewId]: value }));
  };

  const toggleReplyBox = (reviewId) => {
    setReplyOpen((prev) => ({ ...prev, [reviewId]: !prev[reviewId] }));
  };

  const handleSubmitReply = async (reviewId) => {
    const replyText = String(replyDrafts[reviewId] || "").trim();
    if (!replyText) return;

    setReplySubmitting((prev) => ({ ...prev, [reviewId]: true }));
    setReviewMsg("");

    try {
      const res = await fetch(`/api/reviews/${reviewId}/reply`, {
        method: "PUT",
        headers: authHeader(),
        body: JSON.stringify({ reply: replyText }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to save reply");

      setReviews((prev) => prev.map((r) => (r.id === reviewId ? data : r)));
      setReplyOpen((prev) => ({ ...prev, [reviewId]: false }));
      setReviewMsg("Reply saved successfully.");
    } catch (err) {
      console.error(err);
      setReviewMsg("Could not save reply. Please try again.");
    } finally {
      setReplySubmitting((prev) => ({ ...prev, [reviewId]: false }));
    }
  };

  const handleChat = async () => {
    if (!isLoggedIn()) { navigate("/login"); return; }
    await createLead(service._id || service.id).catch(() => {});
    await savePredefinedChatMessage(service.ownerId, service.businessName || service.name).catch(() => {});
    navigate("/kmail/Krivachat", { state: { email: service.ownerId } });
  };

  const handleCall = () => {
    if (service?.phone) window.location.href = `tel:${service.phone}`;
  };

  const handleMap = () => {
    if (service?.area) window.open(`https://maps.google.com/?q=${encodeURIComponent(service.area)}`, "_blank");
  };

  const handleReviewSubmit = async () => {
    if (!isLoggedIn()) { navigate("/login"); return; }
    if (!reviewRating) { setReviewMsg("Please select a rating."); return; }
    if (!reviewText.trim()) { setReviewMsg("Please write a review."); return; }
    setReviewSubmitting(true); setReviewMsg("");
    try {
      const res = await fetch("/api/reviews", {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ serviceId: businessId, rating: reviewRating, comment: reviewText.trim() }),
      });
      if (!res.ok) throw new Error("Failed");
      const saved = await res.json();
      setReviews((prev) => [saved, ...prev]);
      setReviewText(""); setReviewRating(0);
      setReviewMsg("Review submitted! Thank you.");
    } catch { setReviewMsg("Could not submit review. Please try again."); }
    finally { setReviewSubmitting(false); }
  };

  if (loading) return <div style={{ ...S.shell, paddingTop: 100, textAlign: "center", color: "#888" }}>Loading business profile…</div>;
  if (error)   return <div style={{ ...S.shell, paddingTop: 100, textAlign: "center", color: "#c0392b" }}>{error}</div>;
  if (!service) return <div style={{ ...S.shell, paddingTop: 100, textAlign: "center", color: "#888" }}>Business not found.</div>;

  const categories = service.category
    ? service.category.split(",").map((c) => c.trim()).filter(Boolean)
    : [];
  const catalogItems = Array.isArray(service.catalogItems)
    ? service.catalogItems.filter((item) => {
        const status = String(item?.approvalStatus || item?.status || "").toLowerCase();
        if (status === "pending" || status === "rejected") return false;
        if (item?.isApproved === false) return false;
        return true;
      })
    : [];
  const offerItems = catalogItems.length > 0
    ? catalogItems.slice(0, 6).map((item) => item.title || item.name)
    : categories;
  const avgRating = reviews.length
    ? (reviews.reduce((sum, r) => sum + (r.rating || 0), 0) / reviews.length).toFixed(1)
    : null;

  return (
    <>
      <CommonNavbar
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSearch={setSearchQuery}
      />
      <div style={S.shell}>

        <button style={S.backBtn} onClick={() => navigate(-1)}>
          <FaArrowLeft size={12} /> Back to search
        </button>

        {/* ── HERO — CSS handles desktop (left/right) vs mobile (top/bottom) ── */}
        <div className="bp-hero">

          {/* image */}
          <div className="bp-hero-img-wrap">
            {service.photoUrl
              ? <img src={service.photoUrl} alt={service.businessName} className="bp-hero-img"
                  onError={(e) => (e.target.style.display = "none")} />
              : <div className="bp-hero-img-placeholder">🏢</div>
            }
          </div>

          {/* content */}
          <div className="bp-hero-content">
            <div className="bp-hero-body">
              <div className="bp-badges-row">
                <span className="bp-verified-badge">
                  <FaCheckCircle size={11} /> Verified
                </span>
                {categories.map((c) => (
                  <span key={c} className="bp-cat-badge">{c}</span>
                ))}
              </div>

              <h1 className="bp-biz-name">{service.businessName || service.name}</h1>

              {service.description && (
                <p className="bp-tagline">{service.description}</p>
              )}

              {/* <div className="bp-meta-row">
                {(service.rating || avgRating) && (
                  <span className="bp-rating-pill">
                    <FaStar size={11} />
                    {avgRating || Number(service.rating).toFixed(1)}
                  </span>
                )}
                <span className="bp-meta-text">
                  {reviews.length > 0 ? `${reviews.length} review${reviews.length !== 1 ? "s" : ""}` : ""}
                  {service.since ? ` · Since ${service.since}` : service.area ? ` · ${service.area}` : ""}
                </span>
              </div> */}
            </div>

            {/* CTA buttons */}
            <div className="bp-cta-grid">
              {/* <button className="bp-cta bp-cta-call" onClick={handleCall}>
                <FaPhone /> <span>Call</span>
              </button> */}
              <button className="bp-cta bp-cta-chat" onClick={handleChat}>
                <FaCommentDots /> <span>Chat</span>
              </button>
              <button className="bp-cta bp-cta-mail" onClick={handleMail}>
                <FaEnvelope /> <span>Mail</span>
              </button>
            </div>
          </div>
        </div>

        {/* ── sticky nav tabs ── */}
        <nav style={S.navBar}>
          {TABS.map((tab) => (
            <NavItem key={tab} label={tab} active={activeTab === tab} onClick={() => scrollToSection(tab)} />
          ))}
        </nav>

        {/* SECTION: Overview */}
        {/* <div ref={sectionRefs["Overview"]} style={S.sectionWrap}>
          <p style={S.sectionLabel}><span style={{ color: "#f7971e", fontSize: 16 }}>✦</span> Overview</p>
          {offerItems.length > 0 ? (
            <div style={S.description}>
              {offerItems.map((label, i) => (
                <div key={i} style={{ ...S.offerItem, borderBottom: i < offerItems.length - 1 ? "1px solid #f2f4f8" : "none" }}>
                  <div style={{ ...S.offerIcon, background: OFFER_COLORS[i % OFFER_COLORS.length] + "18", color: OFFER_COLORS[i % OFFER_COLORS.length] }}>◈</div>
                  {label}
                </div>
              ))}
            </div>
          ) : <p style={{ color: "#aaa", fontSize: 14 }}>No overview available.</p>}
        </div> */}

        {/* SECTION: Services */}
        <div ref={sectionRefs["Services"]} style={S.sectionWrap}>
          <p style={S.sectionLabel}><span style={{ color: "#f7971e", fontSize: 16 }}>✦</span> Services</p>
          {offerItems.length > 0 ? (
            <div style={S.offerList}>
              {offerItems.map((label, i) => (
                <div key={i} style={{ ...S.offerItem, borderBottom: i < offerItems.length - 1 ? "1px solid #f2f4f8" : "none" }}>
                  <div style={{ ...S.offerIcon, background: OFFER_COLORS[i % OFFER_COLORS.length] + "18", color: OFFER_COLORS[i % OFFER_COLORS.length] }}>◈</div>
                  {label}
                </div>
              ))}
            </div>
          ) : <p style={{ color: "#aaa", fontSize: 14 }}>No services listed.</p>}
        </div>

        {/* SECTION: Catalog */}
        <div ref={sectionRefs["Catalog"]} style={S.sectionWrap}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <p style={{ ...S.sectionLabel, marginBottom: 0 }}><span style={{ color: "#f7971e", fontSize: 16 }}>✦</span> Catalog</p>
            <span style={{ fontSize: 13, color: "#aaa" }}>{catalogItems.length} item{catalogItems.length === 1 ? "" : "s"}</span>
          </div>
          {catalogItems.length === 0
            ? <p style={{ color: "#aaa", fontSize: 14 }}>No catalog items yet.</p>
            : (
              <div style={S.catalogGrid}>
                {catalogItems.map((item, index) => (
                  <div key={index} style={S.catalogCard}
                    onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.10)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.04)"; }}
                  >
                    {(item.photoUrl || item.image) && (
                      <img src={item.photoUrl || item.image} alt={item.title} style={{ ...S.catalogImg, cursor: "pointer" }}
                        onError={(e) => (e.target.style.display = "none")}
                        onClick={() => setPreviewImage(item.photoUrl || item.image)} />
                    )}
                    <div style={S.catalogBody}>
                      <div style={S.catalogTitle}>{item.title || item.name}</div>
                      {item.description && <div style={S.catalogDesc}>{item.description}</div>}
                      <div style={S.catalogPrice}>{item.price}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
        </div>

        {/* SECTION: Business Details */}
        <div ref={sectionRefs["Business Details"]} style={S.sectionWrap}>
          <p style={S.sectionLabel}><span style={{ color: "#f7971e", fontSize: 16 }}>✦</span> Business Details</p>
          <div style={S.detailsCard}>
            <div style={S.detailRow}>
              <div style={S.detailIcon}>🏢</div>
              <div>
                <div style={S.detailLabel}>Business Name</div>
                <div style={S.detailValue}>{service.businessName || service.name || "—"}</div>
              </div>
            </div>
            {service.area && (
              <div style={S.detailRow}>
                <div style={{ ...S.detailIcon, background: "#fef3e2", color: "#f7971e" }}>📍</div>
                <div>
                  <div style={S.detailLabel}>Address / Area</div>
                  <div style={S.detailValue}>{service.area}</div>
                  <button onClick={handleMap} style={{ marginTop: 6, background: "none", border: "1px solid #378ADD", color: "#378ADD", borderRadius: 6, padding: "4px 10px", fontSize: 12, cursor: "pointer", fontWeight: 600 }}>Open in Maps</button>
                </div>
              </div>
            )}
             {categories.length > 0 && (
              <div style={S.detailRow}>
                <div style={{ ...S.detailIcon, background: "#f3e8ff", color: "#7F77DD" }}>📍</div>
                <div>
                  <div style={S.detailLabel}>Pincode</div>
                  <div style={S.detailValue}>{service.pincode}</div>
                </div>
              </div>
            )}
            {service.description && (
              <div style={S.detailRow}>
                <div style={{ ...S.detailIcon, background: "#e8f5e9", color: "#1D9E75" }}>📝</div>
                <div>
                  <div style={S.detailLabel}>Description</div>
                  <div style={S.detailValue}>{service.description}</div>
                </div>
              </div>
            )}
            {categories.length > 0 && (
              <div style={S.detailRow}>
                <div style={{ ...S.detailIcon, background: "#f3e8ff", color: "#7F77DD" }}>🏷️</div>
                <div>
                  <div style={S.detailLabel}>Category</div>
                  <div style={S.detailValue}>{categories.join(", ")}</div>
                </div>
              </div>
            )}
             {categories.length > 0 && (
              <div style={S.detailRow}>
                <div style={{ ...S.detailIcon, background: "#f3e8ff", color: "#7F77DD" }}>🌐</div>
                <div>
                  <div style={S.detailLabel}>Website</div>
                  <div style={S.detailValue}>{service.website}</div>
                </div>
              </div>
            )}
            {/* {service.phone && (
              <div style={{ ...S.detailRow, borderBottom: "none" }}>
                <div style={{ ...S.detailIcon, background: "#e8f5e9", color: "#28a745" }}>📞</div>
                <div>
                  <div style={S.detailLabel}>Phone</div>
                  <div style={S.detailValue}>
                    <a href={`tel:${service.phone}`} style={{ color: "#1D9E75", textDecoration: "none", fontWeight: 600 }}>{service.phone}</a>
                  </div>
                </div>
              </div>
            )} */}
            {service.since && (
              <div style={{ ...S.detailRow, borderBottom: "none" }}>
                <div style={{ ...S.detailIcon, background: "#fff8e1", color: "#f7971e" }}>📅</div>
                <div>
                  <div style={S.detailLabel}>In Business Since</div>
                  <div style={S.detailValue}>{service.since}</div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* SECTION: Reviews */}
        <div ref={sectionRefs["Reviews"]} style={S.sectionWrap}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <p style={{ ...S.sectionLabel, marginBottom: 0 }}><span style={{ color: "#f7971e", fontSize: 16 }}>✦</span> Reviews</p>
            {avgRating && (
              <span style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 15, fontWeight: 700, color: "#f7971e" }}>
                <FaStar size={14} /> {avgRating} / 5 &nbsp;
                <span style={{ color: "#aaa", fontWeight: 400, fontSize: 13 }}>({reviews.length})</span>
              </span>
            )}
          </div>

          {reviews.length === 0
            ? <p style={{ color: "#aaa", fontSize: 14, marginBottom: 20 }}>No reviews yet. Be the first!</p>
            : reviews.map((r, i) => {
               const display = getDisplayName(r.userName || r.userId);
                const initials = (r.userName || r.userId || "U").slice(0, 2).toUpperCase();
                const date = r.createdAt ? new Date(r.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";
                return (
                  <div key={r.id || i} style={S.reviewCard}>
                    <div style={S.reviewHeader}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={S.reviewAvatar}>{initials}</div>
                        <div>
                          <div style={S.reviewAuthor}>{display}</div>
                          <div style={S.reviewDate}>{date}</div>
                        </div>
                      </div>
                      <ReviewStars rating={r.rating || 0} />
                    </div>
                    {r.comment && <div style={S.reviewText}>{r.comment}</div>}
                    {r.reply && (
                      <div style={{ ...S.reviewText, background: "#f2f8ff", padding: 12, borderRadius: 12, marginTop: 12, color: "#16325c" }}>
                        <strong style={{ display: "block", marginBottom: 6, color: "#0f4f91" }}>Business reply</strong>
                        {r.reply}
                      </div>
                    )}
                    {isOwner && (
                      <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
                        {!replyOpen[r.id] ? (
                          <button
                            type="button"
                            style={{ ...S.submitBtn, background: "#fff", color: "#333", border: "1px solid #d1d5db" ,width: 180}}
                            onClick={() => toggleReplyBox(r.id)}
                          >
                            {r.reply ? "Edit reply" : "Reply"}
                          </button>
                        ) : (
                          <>
                            <textarea
                              style={S.textarea}
                              placeholder="Write a reply to this review..."
                              rows={3}
                              value={replyDrafts[r.id] !== undefined ? replyDrafts[r.id] : r.reply || ""}
                              onChange={(e) => handleReplyChange(r.id, e.target.value)}
                            />
                            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                              <button
                                type="button"
                                style={{ borderRadius: 10, padding: "10px 18px", border: "1px solid #d1d5db", background: "#fff", color: "#333", cursor: "pointer" }}
                                onClick={() => toggleReplyBox(r.id)}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                style={{ ...S.submitBtn, opacity: replySubmitting[r.id] ? 0.6 : 1,width: 180 }}
                                onClick={() => handleSubmitReply(r.id)}
                                disabled={replySubmitting[r.id] || !String(replyDrafts[r.id] || r.reply || "").trim()}
                              >
                                {replySubmitting[r.id] ? "Saving..." : r.reply ? "Update reply" : "Post reply"}
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
          }

          <div style={S.addReviewBox}>
            <p style={{ ...S.sectionLabel, marginBottom: 12 }}>✍️ Write a Review</p>
            <div style={{ marginBottom: 10 }}>
              <StarRating value={reviewRating} onChange={setReviewRating} size={28} />
            </div>
            <textarea
              style={S.textarea}
              placeholder="Share your experience with this business…"
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              rows={4}
            />
            {reviewMsg && (
              <p style={{ fontSize: 13, marginBottom: 10, color: reviewMsg.startsWith("Review submitted") ? "#1D9E75" : "#c0392b" }}>
                {reviewMsg}
              </p>
            )}
            <button style={{ ...S.submitBtn, opacity: reviewSubmitting ? 0.6 : 1 }} onClick={handleReviewSubmit} disabled={reviewSubmitting}>
              {reviewSubmitting ? "Submitting…" : "Submit Review"}
            </button>
          </div>
        </div>

      </div>
     {isMobile && <MobileBottomNav activeTab={activeTab} setActiveTab={setActiveTab} />}

      {previewImage && (
        <div style={{
          position: "fixed",
          inset: 0,
          zIndex: 2000,
          background: "rgba(0,0,0,0.75)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
        }}
          onClick={() => setPreviewImage(null)}
        >
          <div style={{ position: "relative", maxWidth: "100%", maxHeight: "100%" }}>
            <img
              src={previewImage}
              alt="Catalog preview"
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                borderRadius: 16,
                boxShadow: "0 24px 64px rgba(0,0,0,0.35)",
              }}
            />
            <button
              type="button"
              onClick={() => setPreviewImage(null)}
              style={{
                position: "absolute",
                top: 12,
                right: 12,
                background: "rgba(255,255,255,0.9)",
                border: "none",
                borderRadius: "50%",
                width: 32,
                height: 32,
                cursor: "pointer",
                fontSize: 18,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
}
